module.exports = __webpack_public_path__ + "static/background-60884df44c1abb34db4f2b626cbfd3a2.jpg";